import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthUser from './AuthUser';
import toast, { Toaster } from 'react-hot-toast';

export default function AddSchoolAgent() {
    const navigate = useNavigate();
    const { http, user } = AuthUser();
    const [users, setUsers] = useState([]);
    const [classes, setClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        user_id: '',
        company_id: user.company_id,
        class: '',
        allocation: ''
    });

    useEffect(() => {
        fetchUsers();
        fetchClasses();
    }, []);

    const fetchUsers = () => {
        // Use the new API endpoint to fetch users filtered by company and department 4
        http.get(`/users_by_company_department?company_id=${user.company_id}&department_id=4`)
            .then((res) => {
                if (res.data.success && Array.isArray(res.data.users)) {
                    setUsers(res.data.users);
                    if (res.data.users.length === 0) {
                        toast.info("No users found with department ID 4");
                    }
                } else {
                    console.error("API response for users is not as expected:", res.data);
                    toast.error("Failed to load users");
                }
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
                toast.error("Error loading users");
            });
    };
    
    const fetchClasses = () => {
        http.get(`/class?company_id=${user.company_id}`)
            .then((res) => {
                if (Array.isArray(res.data.data)) {
                    setClasses(res.data.data);
                } else {
                    console.error("API response for classes is not an array");
                    toast.error("Failed to load classes");
                }
            })
            .catch((error) => {
                console.error("Error fetching classes:", error);
                toast.error("Error loading classes");
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await http.post('/agent_master_add', formData);
            
            if (response.data.success) {
                toast.success("School agent added successfully!");
                navigate('/school_agent_list');
            } else {
                toast.error(response.data.message || "Failed to add school agent");
            }
        } catch (error) {
            console.error("Error adding school agent:", error);
            
            if (error.response && error.response.status === 409) {
                toast.error("This user already has an agent master record for this class");
            } else {
                toast.error(error.response?.data?.message || "An error occurred while adding the school agent");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="container mt-5">
                <Toaster />
                <h3>Add School Agent</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mt-3">
                        <label>Select User <span className="text-danger">*</span></label>
                        <select 
                            id="user_id"
                            name="user_id"
                            className="form-control"
                            value={formData.user_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select a user</option>
                            {users.map(user => (
                                <option key={user.id} value={user.id}>
                                    {user.name} {user.last_name || ''} ({user.email})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group mt-3">
                        <label>Class</label>
                        <select
                            id="class"
                            name="class"
                            className="form-control"
                            value={formData.class}
                            onChange={handleChange}
                        >
                            <option value="">Select a class</option>
                            {classes.map((classItem) => (
                                <option key={classItem.id} value={classItem.class_name}>
                                    {classItem.class_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group mt-3">
                        <label>Allocation</label>
                        <input
                            type="number"
                            id="allocation"
                            name="allocation"
                            className="form-control"
                            value={formData.allocation}
                            onChange={handleChange}
                            placeholder="Enter allocation"
                        />
                    </div>

                    <div className="mt-4">
                        <button 
                            type="submit" 
                            className="btn btn-success me-2"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Adding...' : 'Add School Agent'}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-secondary" 
                            onClick={() => navigate('/school_agent_list')}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}
